import { action } from 'satcheljs';
import { PartialTheme } from '@fluentui/theme';

export default action('MUTATE_FABRIC_DENSITY', (density: PartialTheme) => ({ density }));
